export class ArrayUtils {
  public static sumObjectsInArray(arr: any[] = []): any {
    return arr.reduce((sumObject, obj) => {
      for (const key in obj) {
        if (obj[key] === null || obj[key] === undefined) {
          continue; // Skip keys with null or undefined values
        }
        if (Array.isArray(obj[key])) {
          // If the value is an array, concatenate it with existing array or set it as it is
          sumObject[key] = sumObject[key]
            ? sumObject[key].concat(obj[key])
            : obj[key];
        } else if (typeof obj[key] === 'number') {
          sumObject[key] = (sumObject[key] || 0) + obj[key];
        } else if (typeof obj[key] === 'object') {
          sumObject[key] = this.sumObjectsInArray([obj[key]]);
        } else if (typeof obj[key] === 'boolean') {
          // If the value is a boolean, use the latest one
          sumObject[key] = obj[key];
        } else if (typeof obj[key] === 'string') {
          if (!sumObject.hasOwnProperty(key)) {
            sumObject[key] = obj[key];
          } else if (sumObject[key] !== obj[key]) {
            // If the string values are not the same, create an array containing both values
            sumObject[key] = [sumObject[key], obj[key]];
          }
        }
      }
      return sumObject;
    }, {});
  }
}
